import { makeSx } from '../../../theme/_utils'

export default makeSx({
    NotificationWrapper: {
        position: 'relative',
    },
    NotificationWrapperBubble: {
        position: 'absolute',
        top: 0,
        right: 0,
        borderRadius: '100px',
        transform: 'translate(25%, -25%)',
    },
})
